
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useCustomQuery = <TData, TError = Error>(
    queryKey: string,
    queryFn: (params?: Record<string, string | string[]>) => Promise<TData>,
    params?: Record<string, string | string[]>,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [queryKey, params],
        queryFn: () => queryFn(params),
        ...options,
    });
};